import React, { useEffect, useState } from "react";
// import "../css/grn_new.css";
import { useParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Colors } from "chart.js";


const API = "https://api.mahal.qa/api/v1";

export default function CreateGRN() {
  const { orderId } = useParams();


  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  const [grn, setGrn] = useState({ header: null, items: [] });
  const [loading, setLoading] = useState(false);
  const [remarks, setRemarks] = useState("");
  const [image, setImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const { t, i18n } = useTranslation();

  const formatNumber = (value) => {
    return new Intl.NumberFormat(
      i18n.language === "ar" ? "ar-QA" : "en-US"
    ).format(value);
  };

  const formatGRN = (id) => {
    const base = `GRN-${String(id).padStart(5, "0")}`;

    if (i18n.language !== "ar") return base;

    return base.replace(/\d/g, (d) =>
      new Intl.NumberFormat("ar-QA").format(d)
    );
  };

  const formatDate = (date) => {
    return new Date(date).toLocaleDateString(
      i18n.language === "ar" ? "ar-QA" : "en-US"
    );
  };

  useEffect(() => {
    if (!orderId) return;

    const load = async () => {
      setLoading(true);

      let res = await fetch(`${API}/grn/${orderId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (!res.ok) {
        await fetch(`${API}/grn/${orderId}`, {
          method: "POST",
          headers: { Authorization: `Bearer ${token}` },
        });

        res = await fetch(`${API}/grn/${orderId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
      }

      const data = await res.json();
      setGrn({ header: data.header, items: data.items || [] });
      setLoading(false);
    };

    load();
  }, [orderId, token]);

  if (!orderId) return <p>No order selected</p>;
  if (loading || !grn.header) return <p>Loading GRN...</p>;

  const isConfirmed = grn.header.status === "CONFIRMED";

  /* ---------------- HELPERS ---------------- */
  const updateItem = (id, received) => {
    const updated = grn.items.map(i =>
      i.grn_item_id === id
        ? {
          ...i,
          received_quantity: received,
          rejected_quantity: Math.max(0, i.ordered_quantity - received),
        }
        : i
    );
    setGrn({ ...grn, items: updated });
  };

  const grnNo = formatGRN(grn.header.grn_id);

  const totals = grn.items.reduce(
    (a, i) => {
      a.ordered += Number(i.ordered_quantity || 0);
      a.received += Number(i.received_quantity || 0);
      a.rejected += Number(i.rejected_quantity || 0);
      return a;
    },
    { ordered: 0, received: 0, rejected: 0 }
  );


  /* ---------------- ACTIONS ---------------- */
  const saveGRN = async () => {
    await fetch(`${API}/grn/${grn.header.grn_id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        items: grn.items,
        remarks
      })
    });
    alert("GRN saved");
  };

  const confirmGRN = async () => {
    if (!image) {
      alert("Signature / proof is mandatory before confirming GRN");
      return;
    }

    const res = await fetch(
      `${API}/grn/${grn.header.grn_id}/confirm`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          image_base64: image.base64,
          image_mime: image.mime,
        }),
      }
    );

    const data = await res.json();
    if (!res.ok) return alert(data.error);

    alert("GRN confirmed with image proof");
    window.location.reload();
  };




  const handleImage = e => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = () => {
      const base64 = reader.result.split(",")[1];
      setImage({
        base64,
        mime: file.type
      });
      setImagePreview(reader.result);
    };
    reader.readAsDataURL(file);
  };

  const downloadPDF = async () => {
    const res = await fetch(`${API}/grn/${grn.header.grn_id}/pdf`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Accept-Language": i18n.language,
      },
    });

    if (!res.ok) {
      alert("PDF not available yet");
      return;
    }

    const blob = await res.blob();
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = `GRN-${grn.header.grn_id}.pdf`;
    a.click();

    window.URL.revokeObjectURL(url);
  };
  const printPDF = async () => {
    const res = await fetch(`${API}/grn/${grn.header.grn_id}/pdf`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Accept-Language": i18n.language,
      },
    });

    if (!res.ok) {
      alert("PDF not available");
      return;
    }

    const blob = await res.blob();
    const url = window.URL.createObjectURL(blob);

    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.src = url;
    document.body.appendChild(iframe);

    iframe.onload = () => {
      iframe.contentWindow.print();
    };
  };


  /* ---------------- UI ---------------- */
  return (
    <div className="dashboard_page grn_page" dir={i18n.language === "ar" ? "rtl" : "ltr"}>
      {/* HEADER */}
      <div className="page_header glass">
        <h2>{t("grn_title")}</h2>

        <button className="btn_save glow" onClick={() => navigate(-1)}>
          <i className="fa fa-arrow-left me-2"></i>
          {t("grn_back")}
        </button>

      </div>
      {/* <div className="grn-topbar"> */}
      <div className="grn-top-actions">
        <span className={`grn-status ${grn.header?.status?.toLowerCase()}`}>
          {t("grn_no")}: {grnNo}
        </span>

        {isConfirmed && (
          <button
            className="print-btn"
            title="Print GRN"
            onClick={printPDF}
          >
            <i class="fa fa-print" aria-hidden="true"></i>
          </button>
        )}
      </div>



      <div className="section_card soft mb-3">
        <div className="row">

          {/* Supplier */}
          <div className="col-md-4">
            <div className="grn-info-item">
              <div className="grn-info-icon supplier">
                <i className="fas fa-store"></i>
              </div>

              <div className="grn-info-content">
                <small className="muted">
                  {t("grn_supplier")}
                </small>

                <div className="grn-info-value">
                  {i18n.language === "ar"
                    ? grn.header.supplier_name_arabic || grn.header.supplier_name
                    : grn.header.supplier_name}
                </div>
              </div>
            </div>
            
          </div>

      
          {/* Received By */}
          <div className="col-md-4">
            <div className="grn-info-item">
              <div className="grn-info-icon user">
                <i className="fas fa-user"></i>
              </div>

              <div className="grn-info-content">
                <small className="muted">
                  {t("grn_received_by")}
                </small>

                <div className="grn-info-value">
                  {localStorage.getItem("username")}
                </div>
              </div>
            </div>
          </div>

          {/* GRN Date */}
          <div className="col-md-4">
            <div className="grn-info-item">
              <div className="grn-info-icon date">
                <i className="fas fa-calendar-alt"></i>
              </div>

              <div className="grn-info-content">
                <small className="muted">
                  {t("grn_date")}
                </small>

                <div className="grn-info-value">
                  {formatDate(new Date())}
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div className="row mt-4">

        <div className="col-lg-3 col-md-6">
          <div className="stat_card" id="tour-today-orders">
            <div className="grn-info-icon supplier">
            <i className="fas fa-box-open" style={{ background: "#eef4ff", color: "#ff52f9" }} ></i>
            </div>
            <div>
              <span>{t("grn_total_items")}</span>
              <h3>{formatNumber(grn.items.length)}</h3>
            </div>
          </div>
        </div>


        <div className="col-lg-3 col-md-6">
          <div className="stat_card" id="tour-revenue">
            <div className="grn-info-icon user">
            <i className="fas fa-shopping-cart" id="icon" style={{ background: "#fff7ed", color: "#ea580c" }}></i>
            </div>
            <div>
              <span>{t("grn_total_ordered")}</span>
              <h3>{formatNumber(totals.ordered)}</h3>
            </div>
          </div>
        </div>

        <div className="col-lg-3 col-md-6">
          <div className="stat_card" id="tour-pending">
            <div className="grn-info-icon date">
            <i className="fas fa-check-circle" style={{ background: "#eaf8ea", color: "#16a34a" }}></i>
            </div>
            <div>
              <span>{t("grn_total_received")}</span>
              <h3>{formatNumber(totals.received)}</h3>
            </div>
          </div>
        </div>

        <div className="col-lg-3 col-md-6">
          <div className="stat_card" id="tour-total-orders">
            <div className="grn-info-icon supplier">
            <i className="fas fa-times-circle"  style={{ background: "#fef2f2", color: "#dc2626" }}></i>
            </div>
            <div>
              <span>{t("grn_total_rejected")}</span>
              <h3>{formatNumber(totals.rejected)}</h3>
            </div>
          </div>
        </div>

      </div>


      {/* MAIN CONTENT */}
      <div >
        <div className="row">
          <div className="col-md-8" id="table">
            <table className="table align-middle">
              <thead>
                <tr>
                  <th>{t("grn_product")}</th>
                  <th>{t("grn_uom")}</th>
                  <th>{t("grn_ordered")}</th>
                  <th>{t("grn_received")}</th>
                  <th>{t("grn_rejected")}</th>
                  <th>{t("grn_status")}</th>
                </tr>
              </thead>
              <tbody>
                {grn.items?.map(i => (
                  <tr key={i.grn_item_id}>
                    <td>
                      {i18n.language === "ar"
                        ? i.product_name_arabic || i.product_name
                        : i.product_name}
                    </td>
                    <td>{i.uom}</td>
                    <td>{formatNumber(i.ordered_quantity)}</td>
                    <td>
                      <input
                        type="number"
                        className="form-control form-control-sm"
                        disabled={isConfirmed}
                        value={i.received_quantity}
                        min={0}
                        max={i.ordered_quantity}
                        step="1"
                        onKeyDown={e => {
                          if (e.key === "ArrowUp") e.preventDefault();
                        }}
                        onChange={e => {
                          const value = Number(e.target.value);
                          if (value <= i.ordered_quantity && value >= 0) {
                            updateItem(i.grn_item_id, value);
                          }
                        }}
                      />
                    </td>
                    <td>{formatNumber(i.rejected_quantity)}</td>
                    <td>
                      {i.rejected_quantity > 0 ? (
                        <span className="short">
                          {t("grn_short")} {formatNumber(i.rejected_quantity)}
                        </span>
                      ) : (
                        <span className="ok">{t("grn_perfect")}</span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* SUMMARY */}
          {/* <div className="grn-summary-card">
  <h4>{t("grn_summary")}</h4>

  <div className="col-md-4">
    <span>{t("grn_total_items")}</span>
    <b>{formatNumber(grn.items.length)}</b>
  </div>

  <div className="col-md-4">
    <span>{t("grn_total_ordered")}</span>
    <b>{formatNumber(totals.ordered)}</b>
  </div>

  <div className="col-md-4">
    <span>{t("grn_total_received")}</span>
    <b>{formatNumber(totals.received)}</b>
  </div>

  <div className="col-md-4">
    <span>{t("grn_total_rejected")}</span>
    <b>{formatNumber(totals.rejected)}</b>
  </div>
</div> */}



















        </div> {/* CLOSE row */}
      </div> {/* CLOSE section_card */}

      {/* REMARKS */}
      <div className="mt-3">
        <label className="form-label">{t("grn_remarks")}</label>
        <textarea
          placeholder={t("grn_remarks_placeholder")}
          value={remarks}
          onChange={e => setRemarks(e.target.value)}
        />
      </div>

      {/* SIGN / PROOF AREA */}
      {!isConfirmed && (
        <div
          className="grn-sign-box"
          onClick={() => document.getElementById("grn-proof-input").click()}
        >
          {!imagePreview ? (
            <span className="sign-text">{t("grn_tap_sign")}</span>
          ) : (
            <img src={imagePreview} alt="GRN Proof" className="sign-preview" />
          )}

          <button
            className="camera-btn"
            onClick={e => {
              e.stopPropagation();
              document.getElementById("grn-proof-input").click();
            }}
          >
            📷
          </button>

          <input
            id="grn-proof-input"
            type="file"
            accept="image/*"
            hidden
            onChange={handleImage}
          />
        </div>
      )}



      {/* ACTIONS */}
      <div className="mt-4">

        {!isConfirmed && (
          <><div className="d-flex justify-content-center gap-3">
            <button className="btn btn-outline-orange" onClick={saveGRN}>
              {t("grn_save")}
            </button>

            <button className="btn_save glow" onClick={confirmGRN}>
              {t("grn_confirm")}
            </button>
          </div>
          </>
        )}

        {isConfirmed && (
          <button onClick={downloadPDF} className="btn_save glow">
            <i className="fa fa-download me-2"></i>
            {t("grn_download")}
          </button>
        )}

      </div>


      {isConfirmed && (
        <div className="grn-success">
          {t("grn_success")}
        </div>
      )}
    </div>
  );
}